import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DatasetModel from '../../../../models/pipeline/steps/dataset';
import {FEATURE_FLAGS} from '../../../../services/feature_flags';
import DatasourceModel from '../../../../models/datasource';
import {inputBlurEvent} from '../../../../services/query_builder_events';
import MeasuresGroup from './dataset_attributes/measures/measures';
import DimensionsGroup from './dataset_attributes/dimensions/dimensions';
import FiltersGroup from './dataset_attributes/filters/filters';

export default class QueryBuilderSingleInput extends Component {
    inputRefs = {
        measures: React.createRef(),
        dimensions: React.createRef(),
        filters: React.createRef(),
    };
    queryBuilderRef = React.createRef();

    constructor(props) {
        super(props);

        this.removeAttribute = this.removeAttribute.bind(this);
    }

    componentDidMount() {
        if (FEATURE_FLAGS.FOCUS_COLUMN_INPUT_ON_LOAD) {
            this.inputRefs.measures.current.attributeRefs[0].focusColumnInput();
        }
    }

    removeAttribute(attribute) {
        this.props.onRemove(attribute);
        inputBlurEvent.emit();
    }

    render() {
        const {dataset, onClick} = this.props;

        return (
            <div
                className="query-builder-container"
                onClick={onClick}
                ref={this.queryBuilderRef}
            >
                <div
                    className="input-container"
                    onClick={onClick}
                >
                    <MeasuresGroup
                        dataset={dataset}
                        attributes={dataset.measures}
                        onRemove={this.removeAttribute}
                        ref={this.inputRefs.measures}
                    />
                    {
                        (
                            !FEATURE_FLAGS.HIDE_DIMS_AND_FILTERS ||
                            dataset.measures.length ||
                            dataset.dimensions.length ||
                            dataset.filters.length
                        ) ? (
                            <>
                                <span className="query-builder-filler">by</span>
                                <DimensionsGroup
                                    dataset={dataset}
                                    attributes={dataset.dimensions}
                                    onRemove={this.removeAttribute}
                                    ref={this.inputRefs.dimensions}
                                />
                                <span className="query-builder-filler">where</span>
                                <FiltersGroup
                                    dataset={dataset}
                                    attributes={dataset.filters}
                                    onRemove={this.removeAttribute}
                                    ref={this.inputRefs.filters}
                                />
                            </>
                        ) : null
                    }
                </div>
            </div>
        );
    }
}

QueryBuilderSingleInput.propTypes = {
    datasource: PropTypes.instanceOf(DatasourceModel).isRequired,
    dataset: PropTypes.instanceOf(DatasetModel).isRequired,
};
